import React, { Component, PropTypes } from 'react';
import { findDOMNode } from 'react-dom';
import { Table, Well, Button, Modal, Row, Col, Label } from 'react-bootstrap';
import exportTableAsExcel from '../../utils/exportTableAsExcel';
import formValidation from '../../utils/formValidation';
import { getEnumLong, onInputChange } from '../../utils/helpers';
import { Input } from '../inputs';

export default class HorseList extends Component {
  static propTypes = {
    horses: PropTypes.array.isRequired,
    onDeleteHorse: PropTypes.func,
    isDeletingData: PropTypes.bool,
    onEditHorse: PropTypes.func,
    isPushingData: PropTypes.bool,
    nation: PropTypes.string,
    athlete: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    fetchAthleteByFeiId: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      formErrors: [],
      showConfirmModal: false,
      showEditHorseModal: false,
      horseId: undefined,
      horseData: undefined,
    };

    this.onInputChange = onInputChange().bind(this);
  }

  onGetAthleteByFeiId(refName, type) {
    const { fetchAthleteByFeiId } = this.props;

    const feiId = this.refs[refName].getValue();

    fetchAthleteByFeiId(feiId, type).then(() => {
      this.fillInputs(refName, feiId);
    });
  }

  fillInputs(refName, feiId) {
    const { horseData } = this.state;
    const { athlete } = this.props;

    const a = athlete[feiId];

    if (refName === 'horseFeiId') {
      horseData.details = {
        ...horseData.details,
        ...{
          horseFeiId: a.feiId,
          horseName: a.name,
        },
      };
    }

    this.setState({
      horseData,
    });
  }

  openConfirmModal = horseId => {
    this.setState({
      showConfirmModal: true,
      horseId,
    });
  };

  closeConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
      horseId: undefined,
    });
  };

  openEditHorseModal = (horseId, horse) => {
    const details = { ...horse.details };

    this.setState({
      formErrors: [],
      showEditHorseModal: true,
      horseId,
      horseData: { ...horse, details },
    });
  };

  closeEditHorseModal = () => {
    this.setState({
      formErrors: [],
      showEditHorseModal: false,
      horseId: undefined,
      horseData: undefined,
    });
  };

  handleDeleteHorse = () => {
    const { onDeleteHorse } = this.props;
    const { horseId } = this.state;

    onDeleteHorse(horseId)
      .then(() => {
        this.closeConfirmModal();
      })
      .catch(() => {
        this.closeConfirmModal();
      });
  };

  handleEditHorse = () => {
    const { onEditHorse, addHorse } = this.props;
    const { horseId, horseData } = this.state;

    const data = { horseData };

    data.horseDetails = horseData.details;

    formValidation(data).then(formErrors => {
      this.setState({ formErrors });

      if (!!formErrors.length) {
        return;
      }

      addHorse(horseData);

      onEditHorse(horseId, horseData)
        .then(() => {
          this.closeEditHorseModal();
        })
        .catch(() => {
          this.closeEditHorseModal();
        });
    });
  };

  downloadXls = () => {
    const tableElm = findDOMNode(this.refs.table);

    exportTableAsExcel(
      tableElm,
      'Additional Horses',
      `CVI ${window.cviConfig.cviCity} ${new Date().getFullYear()} - Additional Horses`
    );
  };

  renderLoadFeiId(refName, type) {
    return (
      <Button
        type="button"
        onClick={this.onGetAthleteByFeiId.bind(this, refName, type)}
        tabIndex="-1"
        style={{ marginTop: 0 }}
      >
        <i className="fa fa-refresh" />
      </Button>
    );
  }

  renderConfirmModal() {
    const { showConfirmModal } = this.state;
    const { isDeletingData } = this.props;

    return (
      <Modal show={showConfirmModal} onHide={this.closeConfirmModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to delete this horse?</p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            onClick={this.handleDeleteHorse}
            disabled={isDeletingData}
            bsStyle="primary"
          >
            Yes
          </Button>
          <Button type="button" onClick={this.closeConfirmModal} disabled={isDeletingData}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderEditHorseModal() {
    const { isPushingData } = this.props;
    const { showEditHorseModal, formErrors, horseData } = this.state;

    return (
      <Modal show={showEditHorseModal} onHide={this.closeEditHorseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Horse</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {horseData && (
            <form>
              <Row>
                <Col xs={6}>
                  <Input
                    type="text"
                    onChange={this.onInputChange('horseData.details.horseFeiId')}
                    value={horseData.details.horseFeiId}
                    errors={formErrors}
                    name="horseFeiId"
                    label="Horse FEI ID"
                    buttonAfter={this.renderLoadFeiId('horseFeiId', 'horse')}
                    ref="horseFeiId"
                    refInput="horseFeiId"
                  />
                </Col>

                <Col xs={6}>
                  <Input
                    type="text"
                    onChange={this.onInputChange('horseData.details.horseName')}
                    value={horseData.details.horseName}
                    errors={formErrors}
                    name="horseName"
                    label="Horse Name"
                  />
                </Col>
              </Row>
            </form>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            onClick={this.handleEditHorse}
            disabled={isPushingData}
            bsStyle="primary"
          >
            Submit
          </Button>
          <Button type="button" onClick={this.closeEditHorseModal} disabled={isPushingData}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderTableColumn(horse) {
    const { isAdmin } = this.props;
    const { details } = horse;

    return (
      <tr key={`u_${horse.id}`}>
        <td>{getEnumLong('nations', horse.nation)}</td>
        <td className="no-wrap">{details.horseName}</td>
        <td>{details.horseFeiId}</td>
        <td className="action">
          {process.env.REACT_APP_DISABLED_ENTRIES !== 'true' &&
            !isAdmin && (
              <Button
                type="button"
                bsStyle="warning"
                bsSize="xs"
                onClick={this.openEditHorseModal.bind(this, horse.id, horse)}
              >
                <i className="fa fa-pencil fa-fw" />
              </Button>
            )}
        </td>
        <td className="action">
          {process.env.REACT_APP_DISABLED_ENTRIES !== 'true' &&
            !isAdmin && (
              <Button
                type="button"
                bsStyle="danger"
                bsSize="xs"
                onClick={this.openConfirmModal.bind(this, horse.id)}
              >
                <i className="fa fa-trash fa-fw" />
              </Button>
            )}
        </td>
      </tr>
    );
  }

  render() {
    const { horses, onDeleteHorse, onEditHorse } = this.props;

    return (
      <div>
        {onDeleteHorse && this.renderConfirmModal()}

        {onEditHorse && this.renderEditHorseModal()}

        {!!horses.length && (
          <div>
            <Table striped bordered condensed hover responsive ref="table">
              <thead>
                <tr>
                  <th>Nation</th>
                  <th>Horse Name</th>
                  <th>Horse FEI ID</th>
                  <th className="action">Edit</th>
                  <th className="action">Delete</th>
                </tr>
              </thead>
              <tbody>{horses && horses.map(horse => this.renderTableColumn(horse))}</tbody>
            </Table>

            <Label
              style={{
                fontWeight: 600,
                fontSize: 14,
                padding: '10px 15px',
                float: 'right',
              }}
            >
              {horses.length} horses
            </Label>

            <Button type="button" bsStyle="primary" bsSize="xs" onClick={this.downloadXls}>
              <i className="fa fa-file-excel-o fa-fw" /> Export to Excel
            </Button>
          </div>
        )}

        {!horses.length && <Well>There are no horses</Well>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/horse/HorseList.js